module.exports = __webpack_public_path__ + "static/expert-infotech-0157c9760e7c81fbf8943e10b603658e.png";